<template>
    <Form :rules="rules" :model="formState" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" @finish="onSubmit">
        <FormItem label="旧密码" name="old_password" class="form-item-old">
            <a-input v-model:value="formState.old_password" placeholder="请输入旧密码" />
            <p class="tips" v-if="errorTips?.length > 0">{{ errorTips }}</p>
        </FormItem>
        <FormItem label="新密码" name="new_password" class="form-item-new">
            <a-input v-model:value="formState.new_password" placeholder="请输入新密码" />
        </FormItem>
        <FormItem :wrapper-col="{ span: 24 }">
            <div class="action-btn-wrapper">
                <a-button type="primary" html-type="submit">确认</a-button>
                <a-button class="cancel-btn" @click="$emit('showPsdModal', false)">取消</a-button>
            </div>
        </FormItem>
    </Form>
</template>
<script lang="ts" setup>
import { reactive, toRaw, UnwrapRef, ref } from 'vue'
import { RuleObject } from 'ant-design-vue/es/form/interface'
import { message, Form, FormItem } from 'ant-design-vue'

import { accountApi } from '@/api/account'

interface FormState {
    old_password: string
    new_password: string
}

const emit = defineEmits(['showPsdModal'])

const checkAccount = async (rule: RuleObject, value: string) => {
    errorTips.value = ''
    if (!value) {
        return Promise.reject('请输入旧密码')
    }
    return Promise.resolve()
}
const checkNewPsd = async (rule: RuleObject, value: string) => {
    let reg = /(?!^(\d+|[a-zA-Z]+|[~!@.#$%^&*?]+)$)^[\w.~!@#.$%^&*?]{6,16}$/ //需包含字母，数字，及英文字符中至少两种6-16位
    if (!reg.test(value)) {
        return Promise.reject('密码6-16位，需包括数字、大小写字母、特殊英文字符中至少2种')
    }
    return Promise.resolve()
}
const formState: UnwrapRef<FormState> = reactive({
    old_password: '',
    new_password: ''
})
const rules = {
    old_password: [{ required: true, validator: checkAccount }],
    new_password: [{ required: true, validator: checkNewPsd }]
}

const errorTips = ref('')
const onSubmit = async () => {
    try {
        await accountApi.modifyPw(toRaw(formState))
        errorTips.value = ''
        emit('showPsdModal', false)
        message.success('密码修改成功')
    } catch (err: any) {
        errorTips.value = err.data.message
    }
}
</script>

<style lang="less" scoped>
:deep(.ant-form-item-label) {
    > label {
        height: 32px;
    }
    > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
        display: none;
    }
}

:deep(.ant-form) {
    margin-top: -10px;
}

.action-btn-wrapper {
    display: flex;
    flex-direction: row-reverse;
    .cancel-btn {
        margin-right: 8px;
    }
    .cancel-btn:hover {
        border-color: @primary-color;
        color: @primary-color;
    }
}
.tips {
    position: absolute;
    color: red;
    bottom: 40px;
}
.ant-result {
    position: absolute;
    left: 0;
    top: 15px;
    background: #fff;
    width: 100%;
    padding: 70px 32px;
}
.ant-form-item {
    margin-bottom: 0px;
}
.form-item-old {
    margin-bottom: 16px;
}
.form-item-new {
    margin-bottom: 24px;
}
:deep(.anticon) svg {
    font-size: 60px;
}
:deep(.ant-result-title) {
    margin: -8px 0;
}
:deep(.ant-modal-content) {
    width: 400px;
}
//输入框
.ant-input {
    background: #f7f8fa;
}
:deep(.ant-btn-primary) {
    border-color: @primary-color;
    background: @primary-color;

    &:focus {
        border-color: @primary-color;
        background: @primary-color;
    }

    &:hover {
        border-color: @primary-color;
        background: @primary-color;
        opacity: 0.7;
    }
    &:active {
        border-color: @primary-color;
        background: @primary-color;
        opacity: 0.5;
    }
}
</style>
